import { Mapper } from './mapper';
import { Tag } from 'src/app/entities/tag/tag';
import { TagDto } from 'src/app/services/remote-data-service/dtos/tag.dto';

export class TagMapper extends Mapper<Tag, TagDto> {
  mapToEntity(dto: TagDto): Tag {
    return new Tag(
      dto.uuid,
      dto.name
    );
  }


}
